import { createReducer, on } from '@ngrx/store';

import * as InstitutionActions from './institution.actions';
import {
  institutionStateAdapter,
  initialInstitutionState,
} from './institution.state';

export const reducer = createReducer(
  initialInstitutionState,
  on(InstitutionActions.institutionsLoadedSuccess, (state, action) => ({
    ...institutionStateAdapter.setAll(action.institutions, state),
    // OC-2. setAll, so the store holds the page the member is on rather than
    // accumulating pages. The total comes from the server because the number
    // of entities held is now the page size, not the size of the result.
    institutionsTotalCount: action.totalCount,
    loading: false,
    // selectedInstitutionId: null, TODO: why set this null?
    // selectedInstitutionDetails: null, TODO: why set this null?
  })),
  on(
    InstitutionActions.institutionsLoadedFailure,
    InstitutionActions.loadInstitutionsByProgramFailure,
    (state, { error }) => ({ ...state, error, loading: false })
  ),
  // A failed details read drops the details it failed to replace. Leaving the
  // previous school's payload in place is how the panel came to show one
  // school's figures under another school's name.
  on(InstitutionActions.institutionDetailsLoadedFailure, (state, { error }) => ({
    ...state,
    selectedInstitutionDetails: null,
    error,
    loading: false
  })),
  on(InstitutionActions.loadInstitutions, (state) => ({
    ...state,
    institutionsForOccupationOptions: {
      ...state.institutionsForOccupationOptions,
      skip: 0,
    },
    loading: true,
  })),
  on(InstitutionActions.clearInstitutions, (state) =>
    institutionStateAdapter.removeAll({
      ...state,
      loading: false,
    })
  ),
  on(
    InstitutionActions.updateInstitutionsForOccupationOptions,
    (state, { options }) => ({
      ...state,
      institutionsForOccupationOptions: {
        ...state.institutionsForOccupationOptions,
        ...options,
        /**
         * OC-2. Any filter change returns to the first page. Holding the
         * offset across a change would land a member on page 9 of a set that
         * now has three pages, which reads as an empty result rather than as
         * a narrower one.
         */
        offset: 0,
      },
      loading: true,
    })
  ),
  // OC-2. Paging keeps every filter and moves only the window.
  on(InstitutionActions.setInstitutionsPage, (state, { offset }) => ({
    ...state,
    institutionsForOccupationOptions: {
      ...state.institutionsForOccupationOptions,
      offset,
    },
    loading: true,
  })),
  on(InstitutionActions.clearInstitutionsForOccupationOptions, (state) => ({
    ...state,
    institutionsForOccupationOptions: {
      ...initialInstitutionState.institutionsForOccupationOptions,
    },
    loading: true ,
  })),
  // The id and the details move together. The id used to change on its own,
  // so for the length of the next request the store held school B's id beside
  // school A's details and every consumer that joined the two believed them.
  on(InstitutionActions.setSelectedInstitution, (state, { institutionId }) => ({
    ...state,
    selectedInstitutionId: institutionId,
    selectedInstitutionDetails: null,
    error: null,
  })),
  on(
    InstitutionActions.institutionDetailsLoadedSuccess,
    (state, { institutionDetails }) => ({
      ...state,
      selectedInstitutionDetails: institutionDetails,
      loading: false,
    })
  ),
  on(
    InstitutionActions.loadInstitutionsByProgramSuccess,
    (state, { institutions }) => ({
      ...state,
      institutionsByProgram: institutions,
    })
  )
);
